module.exports = __webpack_public_path__ + "static/media/small-loader.8f1bc17e.svg";